import { JsonObject } from '@bufbuild/protobuf';
import { FileCategory, FileShare } from '@q6cyber/proto2es/generated/fileshare';

import { FormControl, Validators } from '@angular/forms';

import { RouterOutput } from '../../../utils';
import { customFormGroup } from '../utilities';
import { DIGITS_ONLY_PATTERN } from '../validations/regex.validations';
import { CorruptedData } from './generic-data.interface';

export type SubscriptionClient =
  RouterOutput['clientSubscriptions']['listClientsBySubscription']['clients'][number];
export interface FileShareListResponse
  extends
    Omit<RouterOutput['fileShare']['list']['edges'][0], 'node'>,
    CorruptedData {
  node: FileShare | null;
}

/**
 * Display names for every legacy `FileCategory` (the client-portal folders),
 * matching Stalker's `FileCategoryEnum`.
 */
export const FILE_SHARE_CATEGORY_LABELS: Record<FileCategory, string> = {
  [FileCategory.FILE_CATEGORY_UNKNOWN]: 'Unknown',
  [FileCategory.MERCHANT_BREACH]: 'Merchant Intelligence',
  [FileCategory.DATA_DICTIONARY]: 'Data Dictionary',
  [FileCategory.MULE_ACCOUNTS]: 'Mule Accounts Alerts',
  [FileCategory.ACTIVITY_SUMMARY]: 'Summaries of Activity',
  [FileCategory.BLOG_POST]: 'Blog Posts',
  [FileCategory.FRAUD]: 'Fraud Alerts',
  [FileCategory.GENERAL]: 'General',
  [FileCategory.IOC]: 'Indicators of Internal Compromise',
  [FileCategory.TTP_TA_PROFILES]: 'Fraud Insights',
};

/** Folder name for a `FileCategory` enum name; unknown names are returned as-is. */
export const getFileShareCategoryLabel = (category: string): string =>
  FILE_SHARE_CATEGORY_LABELS[
    FileCategory[category as keyof typeof FileCategory]
  ] ?? category;

export const DEFAULT_FILE_SHARE = new FileShare({
  uploadInfo: {},
}).toJson({
  emitDefaultValues: true,
}) as JsonObject;

export const fileShareForm = () => {
  const form = customFormGroup({
    file: new FormControl<File | null>(null, Validators.required),
    subscription: new FormControl<string | null>(null, Validators.required),
    clientName: new FormControl<string[]>([], {
      nonNullable: true,
      validators: Validators.required,
    }),
    uploadInfo: customFormGroup({
      notificationTitle: new FormControl<string>('', Validators.required),
      uploadedBy: new FormControl<string>('', Validators.email),
    }),
    filename: new FormControl<string>(''),
    exportMetricCount: new FormControl<number | null>(null, {
      validators: [
        Validators.required,
        Validators.min(1),
        Validators.pattern(DIGITS_ONLY_PATTERN),
      ],
    }),
    skipNotification: new FormControl<boolean>(false, { nonNullable: true }),
    addBanner: new FormControl<boolean>(false, { nonNullable: true }),
    expirationDate: new FormControl<string | null>(null),
    description: new FormControl<string>(''),
  });
  return form;
};
